"use client";
import { cn } from "@/utils/helpers";
import { useAppStore } from "@/store/app";
import { getControlStatGroups, getControlStats, getLang } from "@/utils/selectors";
import Tooltip from "@/components/common/Tooltip";
import Markdown from "@/components/common/Markdown";
import Columns, { Column } from "@/components/common/Columns";
import ProfileSmokeChart from "./ProfileSmokeChart";
import styles from "../Profile.module.css";

export default function ProfileSmoke() {
	const controls = useAppStore(store => store.controls);
	const selectedLocation = useAppStore(store => store.selectedLocation);

	return (
		<div
			className={styles.ProfileSmoke}
		>
			<Columns
				className={cn(
					styles.ProfileGroups,
					styles.ProfileSmokeGroups
				)}
			>
				{getControlStatGroups().map((group, index) =>
					<Column
						key={index}
						size={6}
						title={getLang("stat", group)}
						titleTag="h3"
						className={cn(
							styles.ProfileGroup,
							styles.ProfileSmokeGroup
						)}
					>
						<div
							className={cn(
								styles.ProfileGroupStats,
								styles.ProfileSmokeGroupStats
							)}
						>
							{getControlStats("smoke", group).map((stat: string, index: number) =>
								<div
									key={index}
									className={cn(
										styles.ProfileStat,
										styles.ProfileSmokeStat
									)}
								>
									<hgroup
										className={cn(
											styles.ProfileStatHeader,
											styles.ProfileSmokeStatHeader
										)}
									>
										<h4
											className={cn(
												styles.ProfileStatTitle,
												styles.ProfileSmokeStatTitle
											)}
										>
											{getLang(controls.view, stat, "title")}
										</h4>
										<Tooltip
											hasIcon={true}
											inner={getLang(controls.view, stat, "tooltip")}
											footer={getLang("stat", "tooltip", "footer")}
											className={cn(
												styles.ProfileStatTitleTooltip,
												styles.ProfileSmokeStatTitleTooltip
											)}
										/>
										<Markdown
											className={cn(
												styles.ProfileStatSubtitle,
												styles.ProfileSmokeStatSubtitle
											)}
										>
											{getLang(controls.view, stat, "subtitle")}
										</Markdown>
									</hgroup>
									<ProfileSmokeChart
										stat={stat}
										location={selectedLocation}
									/>
								</div>
							)}
						</div>
					</Column>
				)}
			</Columns>
		</div>
	);
}